'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotScatterternaryIcon = function PlotScatterternaryIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M30.375 28.688H1.625L16 1.188zM3.75 27.313h24.375L16 4.125zM18.688 16c0 .75-.625 1.313-1.375 1.313C16.625 17.313 16 16.75 16 16s.625-1.313 1.313-1.313c.75 0 1.375.563 1.375 1.313zm2.625 4c0 .75-.563 1.313-1.313 1.313S18.687 20.75 18.687 20s.563-1.313 1.313-1.313 1.313.563 1.313 1.313zm-12 4c0 .75-.563 1.313-1.313 1.313S6.687 24.75 6.687 24 7.25 22.687 8 22.687 9.313 23.25 9.313 24zm8-12c0 .75-.563 1.313-1.313 1.313S14.687 12.75 14.687 12s.563-1.313 1.313-1.313 1.313.563 1.313 1.313zm-4 8c0 .75-.563 1.313-1.313 1.313S10.687 20.75 10.687 20s.563-1.313 1.313-1.313 1.313.563 1.313 1.313zm0 5.313c0 .75-.563 1.375-1.313 1.375s-1.313-.625-1.313-1.375c0-.688.563-1.313 1.313-1.313s1.313.625 1.313 1.313zM24 24a1.32 1.32 0 0 1-1.313 1.313c-.75 0-1.375-.563-1.375-1.313s.625-1.313 1.375-1.313A1.32 1.32 0 0 1 24 24z' })
    );
};

exports.default = PlotScatterternaryIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotScatterternaryIcon.js
// module id = 687
// module chunks = 0